import React from 'react';
import { Link } from 'react-router-dom'
import '../cambio.css';

function Siar() {
    
    return (
        <div>
            <section>

                
                {/*<div class="text-center">
                    
                
                    <div class="my-5"></div>
                        <div class="row justify-content-evenly">
                            <div class="col text-centr2">
                                <button class="btn reportes_btn" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
                                    Recursos Humanos
                                </button>
                            </div>
                        </div>
                        <div class="collapse" id="collapseExample">
                            <div class="row justify-content-evenly">
                                <div class="col">
                                    <a target="_blank" href="https://arbal.wilsoftapp.com/qprocess/Apps/Run/65da82e1-5f43-42e6-8592-69f04f4302a5">
                                        <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                    </a>
                                    <h5>Cuestionario COVID</h5>
                                </div>
                                <div class="col">
                                    <a target="_blank" href="https://arbal.wilsoftapp.com/qprocess/Apps/Run/7555a5c8-76e9-4650-9512-8dc8e14288e1">
                                        <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-02.png" alt="..."></img>
                                    </a>
                                    <h5>Préstamo administrativo</h5>
                                </div>
                                <div class="col">
                                    <a target="_blank" href="https://arbal.wilsoftapp.com/qprocess/Apps/Run/ec34b079-b2bd-4b92-86fb-c9be585d98b6">
                                        <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-03.png" alt="..."></img>
                                    </a>
                                    <h5>Anticipo de nómina</h5>
                                </div>
                            </div>
                        
                            <div class="row justify-content-evenly espacio">
                                
                                <div class="col">
                                    <a target="_blank" href="https://arbal.wilsoftapp.com/qprocess/Apps/Run/656e4de9-00d5-4cca-814d-d08d0369b6be">
                                        <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-02.png" alt="..."></img>
                                    </a>
                                    <h5>Fondo de ahorro</h5>
                                </div>                 
                                <div class="col">
                                    <a target="_blank" href="https://arbal.wilsoftapp.com/qprocess/Apps/Run/069a66f9-f63f-48ff-a6d9-bd883013fa9e">
                                        <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                    </a>
                                    <h5>Reportes</h5>
                                </div>
                            <div class="col">
                                        <a target="_blank" href="https://arbal.wilsoftapp.com/qprocess/AppBasicApps/Login?appID=13b98ed5-bf83-4823-a41e-fb3c88a4aed1">
                                        <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                    </a>
                                    <h5>Bonos operativos</h5>
                                </div>   
                                
                            <div class="row justify-content-evenly espacio">   
                            <div class="col">
                                
                                    <h5></h5>
                                </div>                 
                                <div class="col">
                                    <a target="_blank" href="https://arbal.wilsoftapp.com/qprocess/Apps/Run/cc86bbbc-c510-46c0-91ff-42ab5e073a89">
                                        <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                    </a>
                                    <h5>Retroalimentación de bonos</h5>
                                </div>
                            <div class="col">
                                    
                                        
                                
                                    <h5></h5>
                                </div>    
                            </div> 
                            </div>
                        </div>
                    
                        <div class="row justify-content-evenly color_colum">
                            <div class="col text-centr2">
                                <button class="btn reportes_btn" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample1" aria-expanded="false" aria-controls="collapseExample">
                                    Contabilidad
                                </button>
                            </div>
                        </div>
                        <div class="collapse color_colum" id="collapseExample1">
                            <div class="row justify-content-evenly">                        
                                <div class="col">
                                        <a target="_blank" href="https://arbal.wilsoftapp.com/qprocess/Apps/Run/b7c33767-5d19-4ba4-89ac-fb8f21f8ecbc">
                                            <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                        </a>
                                        <h5>Solicitud de viáticos</h5>
                                </div>
                                
                                <div class="col">
                                        <a target="_blank" href="https://arbal.wilsoftapp.com/qprocess/Apps/Run/2afa5b39-f596-4c32-9f28-442751a1e7b4">
                                            <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-05.png" alt="..."></img>
                                        </a>
                                        <h5>Comprobación de viáticos</h5>
                                </div>
                            </div>
                        </div>

                        <div class="row justify-content-evenly">
                            <div class="col text-centr2">
                                <button class="btn reportes_btn" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample2" aria-expanded="false" aria-controls="collapseExample">
                                    Soporte
                                </button>
                            </div>
                        </div>
                        <div class="collapse" id="collapseExample2">
                            <div class="row justify-content-evenly">  
                                <div class="col">
                                    <a target="_blank" href="">
                                        <img src="" alt=""></img>
                                    </a>
                                    <h5></h5>
                                </div>                 
                            <div class="col">
                                    <a target="_blank" href="https://arbal.wilsoftapp.com/qprocess/Apps/Run/f512c223-5a13-4117-ab3d-f13a66238f44">
                                        <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238109/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-04.png" alt="..."></img>
                                    </a>
                                    <h5>Tickets</h5>
                                </div>
                                <div class="col">
                                        <a target="_blank" href="">
                                        <img src="" alt=""></img>
                                    </a>
                                    <h5></h5>
                                </div>   
                            </div>
                        </div>
                    </div>

                </div>
                
                <div>
                    <div class="row align-items-center bgbackg2">
                        <div class="col-4 text-centr align-items-start">
                            <div className="text-start">
                                <p class="h2">Cultura de datos</p>
                                <h6>1. Reportes bonos</h6>
                                <h6>2. Reportes operaciones</h6>
                                <h6>3. Reportes RH</h6>
                                <h6>4. Reportes Capacitación</h6>
                               <Link to="/Reportes">
                                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620164533/ARBAL/SIAR/Nueva_versi%C3%B3n/1.INICIO_ARBAL-18.png" alt="..."></img>
                               </Link>    
                            </div>
                        </div>
                        <div class="col-6">
                            <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238110/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-09.png" class="img-fluid rounded mx-auto d-block" alt="..."></img>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="row align-items-center">
                        <div class="col-6">
                            <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238110/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-08.png" class="img-fluid rounded mx-auto d-block" alt="..."></img>
                        </div>
                        <div class="col-4 text-centr align-items-start">
                            <div className="text-start">
                                <p class="h2">Capacitación</p>
                                <h6>- Acceso a cursos</h6>
                                <h6>- Videos</h6>
                                <a target="_blank" href="https://arbal.wilsoftapp.com/qtraining/Users/Login?ReturnUrl=%2fqtraining%2f">
                                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620164533/ARBAL/SIAR/Nueva_versi%C3%B3n/1.INICIO_ARBAL-18.png" alt="..."></img>
                                </a>                            
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <div class="row align-items-center bgbackg2">
                        <div class="col-4 text-centr align-items-start">
                            <div className="text-start">
                                <p class="h2">Operaciones</p>
                                <h6>1. Reportar incidencias</h6>
                                <h6>2. Realizar bitácoras</h6>
                                <h6>3. Llenar checklists</h6>
                                <a target="_blank" href="http://movilarbal.dyndns.org:8045/Home/Startup ">
                                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620164533/ARBAL/SIAR/Nueva_versi%C3%B3n/1.INICIO_ARBAL-18.png" alt="..."></img>
                                </a>
                            </div>
                        </div>
                        <div class="col-6">
                            <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238110/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-09.png" class="img-fluid rounded mx-auto d-block" alt="..."></img>
                        </div>
                    </div>
                </div>
                */}
                <div id="carouselExampleIndicators" class="carousel slide mx-5 my-5" data-bs-ride="carousel">
                    <div class="carousel-indicators">
                        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
                        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button>
                    </div>
                    <div class="carousel-inner">
                        <div class="carousel-item active" data-bs-interval="4000">
                            <div class="d-block w-100">
                            <div class="row align-items-center bgbackg1 pb-5">
                                <div class="col-4 text-centr responsive">
                                    <div className="text-start mb-3">
                                        <p class="h2 blanco">Servicios Automatizados</p>
                                        <h7 class="blanco">Estamos más cerca de ti</h7>
                                    </div>
                                    <Link to="/automatizacion">
                                        <button type="button" class="btn red ">Ver más</button>
                                    </Link>
                                </div>
                                <div class="col-6 responsive">
                                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1619739658/ARBAL/SIAR/Nueva_versi%C3%B3n/1.INICIO_ARBAL-17.png" class="img-fluid rounded mx-auto d-block" alt="..."></img>
                                </div>
                            </div>
                            </div>
                        </div>
                        <div class="carousel-item" data-bs-interval="4000">
                            <div class="d-block w-100">
                                <div class="row align-items-center bgbackg2">
                                    <div class="col-4 text-centr align-items-start responsive">
                                        <div className="text-start">
                                            <p class="h2">Cultura de datos</p>
                                            <h6>1. Reportes bonos</h6>
                                            <h6>2. Reportes operaciones</h6>
                                            <h6>3. Reportes RH</h6>
                                            <h6>4. Reportes Capacitación</h6>
                                            <Link to="/Reportes">
                                                
                                                <button type="button" class="btn red">Ver más</button>    
                                            </Link>    
                                        </div>
                                    </div>
                                    <div class="col-6 responsive">
                                        <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238110/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-09.png" class="img-fluid rounded mx-auto d-block" alt="..."></img>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="carousel-item" data-bs-interval="4000">
                            <div class="d-block w-100">
                                <div class="row align-items-center pb-4">
                                    <div class="col-6 responsive">
                                        <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238110/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-08.png" class="img-fluid rounded mx-auto d-block" alt="..."></img>
                                    </div>
                                    <div class="col-4 text-centr align-items-start responsive" style={{ paddingBottom:"7px" }}>
                                        <div className="text-start">
                                            <p class="h2">Capacitación</p>
                                            <h6>- Acceso a cursos</h6>
                                            <h6>- Videos</h6>
                                            <a target="_blank" rel="noreferrer" href="https://arbal.wilsoftapp.com/qtraining/Users/Login?ReturnUrl=%2fqtraining%2f">
                                                <br></br>
                                                <button type="button" class="btn red">Ver más</button>    
                                            </a>                      
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="carousel-item" data-bs-interval="4000">
                            <div class="d-block w-100">
                                <div class="row align-items-center bgbackg2 pb-4" >
                                    <div class="col-4 text-centr align-items-start responsive">
                                        <div className="text-start" style={{ paddingBottom:"3px" }}>
                                            <p class="h2">Operaciones</p>
                                            <h6>1. Reportar incidencias</h6>
                                            <h6>2. Realizar bitácoras</h6>
                                            <h6>3. Llenar checklists</h6>
                                            <a target="_blank" rel="noreferrer" href="http://movilarbal.dyndns.org:8045">
                                                <button type="button" class="btn red">Ver más</button>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="col-6 responsive">
                                        <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238110/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-09.png" class="img-fluid rounded mx-auto d-block" alt="..."></img>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button class="carousel-control-prev prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                        <span class="carousel-prev" aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                    </button>
                    <button class="carousel-control-next next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                        <span class="carousel-next" aria-hidden="true"></span>
                        <span class="visually-hidden">Next</span>
                    </button>
                </div>


                {/* <div>
                    <div class="row align-items-center bgbackg2">
                        <div class="col-6">
                            <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/v1620238110/ARBAL/SIAR/Nueva_versi%C3%B3n/servicios/2.SERVICIOS_ARBAL-10.png" class="img-fluid rounded mx-auto d-block" alt="..."></img>
                        </div>
                        <div class="col-4 text-centr align-items-start">
                            <div className="text-start">
                                <p class="h2">Quién es quién</p>
                                <h4>Sube y consulta expedientes</h4>
                                <a target="_blank" href="http://quienesquien.arbal.int">
                                <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/c_scale,w_110/v1623689299/ARBAL/SIAR/Nueva_versi%C3%B3n/Botones_nuevos-01.png" alt="..."></img>
                                </a>
                                <br>
                                </br>
                                <br>
                                </br>
                                <a target="_blank" href="http://movilarbal.dyndns.org:90/Account/Login?ReturnUrl=%2F">
                                <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/c_scale,w_120/v1623689299/ARBAL/SIAR/Nueva_versi%C3%B3n/Botones_nuevos-02.png" alt="..."></img>
                                </a>
                            </div>
                        </div>
                    </div>
                </div> */}
            </section>
        </div>
    )
}

export default Siar
